import { ReservationSkipOffersIfEditorOutput } from './reservation-skip-offers-if-editor-output';

export const defaultReservationSkipOffersIfEditorOutput: ReservationSkipOffersIfEditorOutput = {
  skipIfUnavailable: true,
  skipIfNumCallsInProgressGE: 1,
};
